import {
  BookmarkCreate,
  DirectoryHeader,
  InfoIconUrl,
} from '@atlas-frontend/sdk';
import { tVisualValidation } from './VisualValidation';
import { VisualValidationNavigationButtons } from './VisualValidationNavigationButtons';
import React, { FC } from 'react';

type VisualValidationHeaderProps = {
  infoIconUrl?: InfoIconUrl;
};

export const VisualValidationHeader: FC<VisualValidationHeaderProps> = (
  props,
) => {
  const { infoIconUrl } = props;
  return (
    <DirectoryHeader
      title={tVisualValidation('title')}
      infoIconUrl={infoIconUrl}
      bookmarkCreate={
        <BookmarkCreate
          excludeUrlParams={[
            'comparisonValueDate1',
            'comparisonValueDate2',
            'comparisonVersion1',
            'comparisonVersion2',
            'valueDate',
            'valueDateFrom',
            'valueDateTo',
            'version',
            'versionRule',
            'versionRule2',
          ]}
        />
      }
      extraActions={<VisualValidationNavigationButtons />}
      justifyExtraActions="flex-start"
    />
  );
};
